/* Niclas + ChatGPT | 2026-10-17 | Optional draft UX. Shopify owns final pricing. */
(() => {
  if (customElements.get('avolt-atelier-trio')) return;
  let pending = false;
  async function addItems(host, items, button) {
    if (host.busy || pending) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.classList.contains('is-cart-loading')) return;
    const error = host.querySelector('.avolt-atelier-error');
    host.busy = true;
    pending = true;
    drawer?.setLoadingStatus?.(true);
    drawer?.emit?.('start-update', {});
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    let added = false;
    try {
      const payload = { items, sections_url: window.location.pathname };
      if (drawer?.dataset.sectionId) payload.sections = [drawer.dataset.sectionId];
      const response = await fetch(host.dataset.url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || data.status || data.errors) {
        throw new Error(typeof data.description === 'string' ? data.description : host.dataset.error);
      }
      added = true;
      const first = data.items?.[0];
      let html = data.sections?.[drawer?.dataset.sectionId];
      if (drawer && !html) {
        const refresh = new URL(window.location.href);
        refresh.searchParams.set('section_id', drawer.dataset.sectionId);
        const sectionResponse = await fetch(refresh);
        if (!sectionResponse.ok) throw new Error(host.dataset.error);
        html = await sectionResponse.text();
      }
      if (drawer && first && html && typeof drawer.purchaseHandler === 'function') {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!parsed.querySelector('[data-sidebar-template="CartDrawer"]')) throw new Error(host.dataset.error);
        drawer.updateAsideProductsByParsedState?.(first);
        await drawer.purchaseHandler(parsed, first);
      } else {
        window.location.assign(host.dataset.cartUrl || window.routes?.cart_url || '/cart');
      }
    } catch (failure) {
      if (added) {
        window.location.assign(host.dataset.cartUrl || window.routes?.cart_url || '/cart');
      } else {
        error.textContent = failure.message || host.dataset.error;
        error.hidden = false;
      }
    } finally {
      host.busy = false;
      pending = false;
      drawer?.setLoadingStatus?.(false);
      drawer?.emit?.('stop-update', {});
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
  customElements.define('avolt-atelier-add', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', event => event.stopPropagation());
      this.querySelector('[data-atelier-add]').addEventListener('click', event => {
        const id = Number(this.querySelector('[data-atelier-variant]').value);
        if (Number.isSafeInteger(id) && id > 0) addItems(this, [{ id, quantity: 1 }], event.currentTarget);
      });
    }
  });
  customElements.define('avolt-atelier-info', class extends HTMLElement {
    connectedCallback() {
      if (this.bound || !window.HTMLDialogElement?.prototype.showModal) return;
      const details = this.querySelector('details');
      const trigger = details?.querySelector('summary');
      const content = details?.querySelector('.avolt-atelier-info__content');
      if (!trigger || !content) return;
      this.bound = true;
      const dialog = document.createElement('dialog');
      dialog.className = 'avolt-atelier-info__dialog';
      dialog.setAttribute('aria-label', trigger.getAttribute('aria-label'));
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'avolt-atelier-info__close';
      close.textContent = '×';
      close.setAttribute('aria-label', this.dataset.closeLabel);
      close.addEventListener('click', () => dialog.close());
      dialog.append(close, content);
      this.append(dialog);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', event => {
        event.preventDefault();
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        this.dispatchEvent(new Event('toggle', { bubbles: true }));
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
        this.dispatchEvent(new Event('toggle', { bubbles: true }));
      });
    }
  });
  function makePicker(host, select) {
    if (!window.HTMLDialogElement?.prototype.showModal) return;
    const el = (tag, cls, text) => {
      const node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const options = [...select.options].sort((a,b) => Number(a.dataset.rank)-Number(b.dataset.rank));
    const chosen = select.value;
    select.append(...options);
    select.value = chosen;
    const control = select.closest('.avolt-atelier-slot__control');
    const slot = select.closest('.avolt-atelier-slot');
    const trigger = el('button', 'avolt-atelier-picker-trigger avolt-premium-tile');
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    const art = el('span', 'avolt-premium-tile__art');
    const image = slot.querySelector('[data-atelier-image]');
    const change = el('span', 'avolt-premium-tile__change');
    change.setAttribute('aria-hidden', 'true');
    const swap = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    Object.entries({ viewBox: '0 0 24 24', width: '16', height: '16', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', focusable: 'false' }).forEach(([key, value]) => swap.setAttribute(key, value));
    const arrows = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrows.setAttribute('d', 'M5 8a8 8 0 0 1 13-2l3 3M21 4v5h-5M19 16a8 8 0 0 1-13 2l-3-3M3 20v-5h5');
    swap.append(arrows);
    change.append(swap);
    art.append(image, change);
    const name = el('span', 'avolt-premium-tile__name');
    const specs = el('span', 'avolt-premium-tile__specs');
    trigger.append(art, name, specs);
    const dialog = el('dialog', 'avolt-atelier-picker avolt-premium-picker');
    const title = el('h3', '', host.dataset.pickerTitle);
    title.id = select.id + '-title';
    dialog.setAttribute('aria-labelledby', title.id);
    const header = el('div','avolt-premium-picker__header');
    const close = el('button','avolt-atelier-picker__close','×');
    close.type = 'button';
    close.setAttribute('aria-label',host.dataset.pickerClose);
    header.append(title,close);
    const body = el('div','avolt-premium-picker__body');
    const preview = el('div','avolt-premium-picker__preview');
    const previewImage = el('img');
    previewImage.width=192; previewImage.height=192; previewImage.alt='';
    const previewCopy = el('div');
    const previewName = el('p','avolt-premium-picker__name');
    const previewSpecs = el('p','avolt-premium-picker__specs');
    const previewPrice = el('p','avolt-premium-picker__price');
    previewCopy.append(previewName,previewSpecs,previewPrice);
    preview.append(previewImage,previewCopy);
    const modelLabel = el('p','avolt-premium-picker__label',host.dataset.modelLabel);
    const models = el('div','avolt-premium-models');
    models.setAttribute('role','group'); models.setAttribute('aria-label',host.dataset.modelLabel);
    const colourLabel = el('p','avolt-premium-picker__label');
    const colours = el('div','avolt-premium-colours');
    colours.setAttribute('role','group'); colours.setAttribute('aria-label',host.dataset.colourLabel);
    body.append(preview,modelLabel,models,colourLabel,colours);
    const footer = el('div','avolt-premium-picker__footer');
    const remove = el('button','avolt-premium-remove',host.dataset.removeLabel);
    const done = el('button','avolt-premium-done',host.dataset.doneLabel);
    remove.type=done.type='button'; footer.append(remove,done);
    dialog.append(header,body,footer);
    let draft;
    const key = option => option.dataset.rank === '4' ? option.dataset.productType+'|'+option.dataset.specs : option.dataset.rank;
    const groups = new Map();
    options.forEach(option => {
      const k=key(option);
      if (!groups.has(k)) groups.set(k,[]);
      groups.get(k).push(option);
    });
    models.style.setProperty('--model-count',String(Math.min(3,groups.size)));
    const modelButtons = new Map();
    const modelNumber = new Intl.NumberFormat(host.dataset.locale);
    const groupName = option => {
      const rank=option.dataset.rank;
      if(rank==='1') return 'Square\u00a01\u00a0· '+modelNumber.format(1.8)+'\u00a0m';
      if(rank==='2') return 'Square 2';
      if(rank==='3') return 'Square\u00a01\u00a0· 3\u00a0m';
      if(rank==='5') return 'USB-C → USB-C';
      if(rank==='6') return 'USB-C → Lightning';
      return option.dataset.model+' · '+option.dataset.specs;
    };
    function renderDraft() {
      previewImage.src=draft.dataset.image;
      previewName.textContent=draft.dataset.model;
      previewSpecs.textContent=draft.dataset.colour+' · '+draft.dataset.specs;
      previewPrice.textContent=draft.dataset.priceLabel;
      colourLabel.textContent=host.dataset.colourLabel+' · '+draft.dataset.colour;
      for(const [k,b] of modelButtons) b.setAttribute('aria-pressed',String(k===key(draft)));
      colours.replaceChildren();
      for(const option of groups.get(key(draft))) {
        const b=el('button'); b.type='button';
        b.setAttribute('aria-label',option.dataset.colour+' · '+option.dataset.priceLabel);
        b.setAttribute('aria-pressed',String(option===draft));
        b.title=option.dataset.colour;
        const img=el('img');img.src=option.dataset.image;img.alt='';img.width=64;img.height=64;img.loading='eager';
        b.append(img);
        b.addEventListener('click',()=>{
          draft=option;
          previewImage.src=option.dataset.image;
          previewName.textContent=option.dataset.model;
          previewSpecs.textContent=option.dataset.colour+' · '+option.dataset.specs;
          previewPrice.textContent=option.dataset.priceLabel;
          colourLabel.textContent=host.dataset.colourLabel+' · '+option.dataset.colour;
          [...colours.children].forEach(node=>node.setAttribute('aria-pressed',String(node===b)));
        });
        colours.append(b);
      }
    }
    for(const [k,values] of groups) {
      const button=el('button'); button.type='button';
      button.append(el('span','',groupName(values[0])),el('span','',values[0].dataset.priceLabel));
      button.addEventListener('click',()=>{
        draft=values.find(option=>option.dataset.colour===draft.dataset.colour)||values[0];
        renderDraft();
      });
      modelButtons.set(k,button);models.append(button);
    }
    trigger.addEventListener('click',()=>{
      draft=select.selectedOptions[0];renderDraft();
      remove.hidden=host.querySelectorAll('[data-atelier-choice]').length<=Number(host.dataset.threshold);
      dialog.showModal();trigger.setAttribute('aria-expanded','true');
      host.dispatchEvent(new Event('toggle',{bubbles:true}));
    });
    done.addEventListener('click',()=>{
      delete select.dataset.pending;
      select.value=draft.value;select.dispatchEvent(new Event('change',{bubbles:true}));dialog.close();
    });
    remove.addEventListener('click',()=>{
      dialog.close();slot.remove();host.updatePrice();host.querySelector('[data-atelier-add-slot]').focus();
    });
    close.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{
      if(event.target!==dialog)return;
      const r=dialog.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
    });
    dialog.addEventListener('close',()=>{
      if (select.dataset.pending) {
        slot.remove();host.updatePrice();host.querySelector('[data-atelier-add-slot]').focus();
        return;
      }
      trigger.setAttribute('aria-expanded','false');trigger.focus({preventScroll:true});
      host.dispatchEvent(new Event('toggle',{bubbles:true}));
    });
    select.atelierPicker={sync(){
      const option=select.selectedOptions[0];
      name.textContent=option.dataset.colour;
      specs.textContent=groupName(option);
      trigger.setAttribute('aria-label',host.dataset.pickerChange+' · '+option.dataset.model+' · '+option.dataset.colour+' · '+option.dataset.specs);
    }};
    control.classList.add('avolt-atelier-slot__control--enhanced');
    control.append(trigger,dialog);select.hidden=true;
  }
  customElements.define('avolt-atelier-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.railBound) return;
      this.railBound = true;
      this.addEventListener('keydown', event => {
        const vertical = this.dataset.axis === 'vertical';
        const keys = vertical ? ['ArrowUp','ArrowDown','Home','End'] : ['ArrowLeft','ArrowRight','Home','End'];
        if (event.target !== this || !keys.includes(event.key)) return;
        event.preventDefault();
        const maximum = vertical ? this.scrollHeight - this.clientHeight : this.scrollWidth - this.clientWidth;
        const current = vertical ? this.scrollTop : this.scrollLeft;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? maximum : current + (['ArrowRight','ArrowDown'].includes(event.key) ? 140 : -140);
        this.scrollTo({[vertical ? 'top' : 'left']:Math.max(0,Math.min(maximum,next)),behavior:'instant'});
      });
    }
  });
  customElements.define('avolt-atelier-trio', class extends HTMLElement {
    connectedCallback() {
      this.bindStickyGuard();
      if (this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-atelier-choice]').forEach(select => {
        select.addEventListener('change', () => this.updatePrice());
        makePicker(this, select);
      });
      this.slotSequence = this.querySelectorAll('[data-atelier-choice]').length;
      const addSlot = this.querySelector('[data-atelier-add-slot]');
      addSlot?.addEventListener('click', () => {
        const first = this.querySelector('[data-atelier-choice]');
        const slot = document.createElement('div');
        slot.className = 'avolt-atelier-slot';
        const control = document.createElement('div');
        control.className = 'avolt-atelier-slot__control';
        const select = first.cloneNode(true);
        select.id = first.id + '-extra-' + (++this.slotSequence);
        select.value = first.value;
        select.dataset.pending = 'true';
        select.hidden = false;
        const label = document.createElement('label');
        label.id = select.id + '-label'; label.htmlFor = select.id;
        label.textContent = this.dataset.pickerTitle;
        const image = document.createElement('img');
        image.setAttribute('data-atelier-image','');
        image.width = image.height = 96; image.alt = '';
        control.append(label, select);slot.append(image,control);
        addSlot.before(slot);
        select.addEventListener('change', () => this.updatePrice());
        makePicker(this,select);
        this.updatePrice();
        slot.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
        const trigger=slot.querySelector('.avolt-atelier-picker-trigger');
        trigger?.click();
      });
      this.querySelector('[data-atelier-submit]').addEventListener('click', event => {
        const quantities = new Map();
        for (const select of this.querySelectorAll('[data-atelier-choice]')) {
          const id = Number(select.value);
          if (!Number.isSafeInteger(id) || id <= 0) return;
          quantities.set(id, (quantities.get(id) || 0) + 1);
        }
        const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
        addItems(this, items, event.currentTarget);
      });
      this.updatePrice();
    }
    disconnectedCallback() {
      this.stickyAbort?.abort();
      this.stickyResize?.disconnect();
      if (this.stickyFrame != null) cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
      this.stickyRoot?.removeAttribute('data-avolt-set-before-scroll');
    }
    bindStickyGuard() {
      this.stickyAbort?.abort();
      this.stickyResize?.disconnect();
      if (this.stickyFrame != null) cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
      const root = this.closest('product-info');
      if (!root) return;
      this.stickyRoot = root;
      const update = () => {
        this.stickyFrame = null;
        const builder = this.querySelector('[data-atelier-builder]');
        const expanded = builder ? builder.open : Boolean(this.querySelector('[data-atelier-visual]'));
        const beforeEnd = this.getBoundingClientRect().bottom > 0;
        const pickerOpen = Boolean(this.querySelector('dialog[open]'));
        root.toggleAttribute('data-avolt-set-before-scroll', Boolean(expanded && (beforeEnd || pickerOpen)));
      };
      const schedule = () => {
        if (this.stickyFrame == null) this.stickyFrame = requestAnimationFrame(update);
      };
      this.stickyAbort = new AbortController();
      const signal = this.stickyAbort.signal;
      window.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      this.addEventListener('toggle', schedule, { capture: true, signal });
      if (window.ResizeObserver) {
        this.stickyResize = new ResizeObserver(schedule);
        this.stickyResize.observe(this);
      }
      update();
    }
    formatPrice(cents) {
      // Liquid's money filter supplies the active market's prefix, suffix and separators.
      // A fixed sample avoids assuming that language determines currency formatting.
      const sample = this.dataset.moneyExample || '';
      const match = sample.match(/^(.*?)([0-9][0-9.,'’\s]*[0-9])(.*?)$/);
      if (!match) return (cents / 100).toFixed(2);
      const fraction = match[2].match(/([.,])89$/);
      const integerSample = fraction ? match[2].slice(0, -3) : match[2];
      const group = integerSample.match(/[^0-9]/)?.[0] || '';
      const parts = (cents / 100).toFixed(fraction ? 2 : 0).split('.');
      const integer = group ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group) : parts[0];
      return match[1] + integer + (fraction ? fraction[1] + parts[1] : '') + match[3];
    }
    updatePrice() {
      let original = 0;
      const prices = [];
      let slotIndex = 0;
      const previews = this.querySelectorAll('[data-atelier-preview]');
      for (const select of this.querySelectorAll('[data-atelier-choice]')) {
        const option = select.selectedOptions[0];
        if (!option) continue;
        original += Number(option.dataset.price);
        prices.push(Number(option.dataset.price));
        const image = select.closest('.avolt-atelier-slot').querySelector('[data-atelier-image]');
        image.src = option.dataset.image;
        image.alt = option.dataset.alt;
        const preview = previews[slotIndex++];
        if (preview) preview.src = option.dataset.image;
        select.atelierPicker?.sync();
      }
      let discounted = Math.round(original * (100 - Number(this.dataset.percent)) / 100);
      if (this.dataset.offerType === 'buy_x_get_y') {
        const paid = Number(this.dataset.buyQuantity);
        const free = Number(this.dataset.getQuantity);
        const sets = Math.floor(prices.length / (paid + free));
        const freeCount = (this.dataset.repeat === 'true' ? sets : Math.min(1, sets)) * free;
        discounted = original - prices.sort((a, b) => a - b).slice(0, freeCount).reduce((sum, price) => sum + price, 0);
      }
      const count = prices.length;
      const submit = this.querySelector('[data-atelier-submit]');
      submit.textContent = this.dataset.submitLabel.replace('__COUNT__',String(count));
      const saving = this.querySelector('[data-atelier-saving]');
      if (saving) saving.textContent = this.dataset.savingLabel.replace('__AMOUNT__',this.formatPrice(original-discounted));
      this.querySelector('[data-atelier-original]').textContent = this.formatPrice(original);
      this.querySelector('[data-atelier-total]').textContent = this.formatPrice(discounted);
    }
  });
})();
